<template>
	<BasePublishCategory :fetch="{start_position_with: '01', hierarhy_by_position: true, response_fields: ['title','code','url_without_domain','children']}" v-slot="{item: category}">
		<BasePublishPostsWidget
			v-if="category?.code"
			:fetch="{category_code: category.code, limit: 4, extra_fields: ['short_description'], response_fields: ['id', 'url_without_domain', 'category_url_without_domain', 'category_title', 'title', 'short_description', 'main_image_upload_path']}"
			thumb-preset="publishSmall"
			featured-posts="1"
			featured-thumb-preset="publishBig"
			v-slot="{items, featuredPosts}">
			<div class="pw" v-if="featuredPosts">
				<div class="wrapper">
					<div class="pw-row">
						<div class="pw-col1">
							<ClientOnly>
								<div class="pw-col1-header">
									<div class="pw-title hp-title">{{ labels.get('blog') }}</div>
									<div class="btn btn-white btn-mobile pw-categories-btn">
										{{ labels.get('m_categories') }}
										<div class="pw-categories-btn-cnt"></div>
									</div>
								</div>
							</ClientOnly>
							<ul class="pw-nav" v-if="category.children">
								<li v-for="blogCategory in category.children" :key="blogCategory.id">
									<NuxtLink :to="blogCategory.url_without_domain">
										<span>{{ blogCategory.title }}</span>
										<ClientOnly>
											<span class="pw-nav-img" v-if="blogCategory.main_image_upload_path">
												<BaseUiImage loading="lazy" :src="blogCategory.main_image_upload_path" :alt="blogCategory.title" width="40" height="40" />
											</span>
										</ClientOnly>
									</NuxtLink>
								</li>
							</ul>
							<NuxtLink :to="category.url_without_domain" class="btn btn-arrow pw-btn pw-btn-d">
								<span>{{ labels.get('show_all') }}</span>
							</NuxtLink>
						</div>
						<div class="pw-col2">
							<ClientOnly>
								<div class="pw-items">
									<div class="pw-items-col1">
										<div class="hp-p-featured">
											<PublishIndexEntry :item="featuredPosts[0]" mode="big" :short-description="true" />
										</div>
									</div>
									<div class="pw-items-col2">
										<PublishIndexEntry v-for="post in items" :key="post.id" :item="post" mode="latest" />
									</div>
									<NuxtLink :to="category.url_without_domain" class="btn btn-arrow pw-btn pw-btn-m">
										<span>{{ labels.get('show_all') }}</span>
									</NuxtLink>
								</div>
							</ClientOnly>
						</div>
					</div>
				</div>
			</div>
		</BasePublishPostsWidget>
	</BasePublishCategory>
</template>

<script setup>
	const labels = useLabels();
</script>

<style lang="less" scoped>
	.pw {
		padding: 125px 0 135px; content-visibility: auto; contain-intrinsic-size: 780px;

		@media (max-width: @l) {
			padding: 115px 0 120px;
		}
		@media (max-width: @t) {
			padding: 70px 0 80px;
		}
		@media (max-width: @m) {
			padding: 50px 0 60px;
		}
		@media (max-width: @ms) {
			padding: 20px 0 30px;
		}
	}
	.pw-row {
		display: flex;

		@media (max-width: @ms) {
			display: block;
		}
	}
	.pw-col1 {
		width: 300px; flex-shrink: 0; padding-right: 40px;

		@media (max-width: @l) {
			width: 260px;
		}
		@media (max-width: @t) {
			width: 200px;
		}
		@media (max-width: @m) {
			display: none;
		}
		@media (max-width: @ms) {
			display: block;
			width: 100%;
			flex-shrink: unset;
			padding: 0;
		}
	}
	.pw-col1-header {
		@media (max-width: @m) {
			display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px;
		}
		@media (max-width: @ms) {
			flex-wrap: wrap; margin: 0;
		}
	}
	.pw-title {
		@media (max-width: @ms) {
			width: 100%;
		}
	}
	.pw-categories-btn {
		@media (max-width: @m) {
			min-width: 290px;
			&.active {
				.pw-categories-btn-cnt { max-height: 1500px; height: unset; opacity: 1; visibility: visible; }
			}
		}
		@media (max-width: @ms) {
			font-size: 0; height: unset; min-width: unset; width: 100%; background: @white; border: none; padding: 0;
		}
	}
	.pw-categories-btn-cnt {
		@media (max-width: @m) {
			width: calc(~'100% - -2px'); position: absolute; top: 100%; left: -1px; right: -1px; background: @white; border: 1px solid @borderColor; z-index: 111; opacity: 0; visibility: hidden; max-height: 0; height: 0;
			.transition(opacity);
		}
		@media (max-width: @ms) {
			width: 100%; position: relative; top: unset; right: unset; left: unset; bottom: unset; border: none; opacity: 1; visibility: visible; max-height: unset; height: unset;
		}
	}
	.pw-col2 {
		flex-grow: 1;

		@media (max-width: @ms) {
			flex-grow: 1;
		}
	}
	.pw-nav {
		list-style: none; font-size: 18px; letter-spacing: -0.3px; padding-top: 25px;
		& > li {
			padding: 0 0 9px;
			& > a {
				color: @textColor; display: block; text-decoration: none;
				&:hover { color: @blue; text-decoration: underline; }
			}
		}

		@media (max-width: @t) {
			font-size: 14px; padding-top: 15px;
			& > li {
				padding: 0 0 6px;
				& > a {
					text-decoration: underline; text-decoration-color: @blue;
					&:hover { color: @textColor; } }
			}
		}
		@media (max-width: @m) {
			font-size: 14px; padding: 8px 15px; & > li {
				padding: 0 0 8px;
				& > a {
					line-height: 1.4; text-decoration: none;
					&:hover { text-decoration: none; }
				}
			}
		}
		@media (max-width: @ms) {
			display: flex; flex-wrap: wrap; padding: 15px 0 10px;
			& > li {
				width: calc(~'100% / 2');
				padding: 0 10px 15px 0;
				& > a {
					padding-left: 25px; position: relative; display: flex; align-items: center;
					.pw-nav-img {
						display: flex; align-items: center; justify-content: center; width: 15px; height: 16px; position: absolute; left: 0;
						:deep(img) { width: auto; height: auto; max-width: 15px; max-height: 16px; display: block; opacity: 0.7; }
					}
				}
			}
		}
	}
	.pw-nav-img { display: none; }
	.pw-btn {
		margin-top: 25px; padding: 0;
		&:after { content: none; }

		@media (max-width: @t) {
			margin-top: 14px; padding: 0;
		}
		@media (max-width: @m) {
			margin-top: 5px; padding: 0;
		}
		@media (max-width: @ms) {
			display: inline-flex; width: unset; min-width: 100%; left: 50%; transform: translateX(-50%); margin-top: 0;
		}
	}
	.pw-btn-d{
		@media (max-width: @ms){display: none;}
	}
	.pw-btn-m{display: none;
		@media (max-width: @ms){display: flex;}
	}

	.pw-items {
		display: flex;

		@media (max-width: @ms) {
			display: block;
		}
	}
	.pw-items-col1 { flex-grow: 1; }
	.pw-items-col2 {
		width: 490px; flex-shrink: 0;

		@media (max-width: @l) {
			width: 394px;
		}
		@media (max-width: @t) {
			width: 305px;
		}
		@media (max-width: @m) {
			width: 290px;
		}
		@media (max-width: @ms) {
			width: 100%;
			flex-shrink: unset;
		}
	}
</style>
